class LeakedPasswordInfo {
    constructor() {
        $('#leaked_password_modal').on('hidden.bs.modal', function () {
            $.ajax({
                url: '?do=closeLeakedPasswordModal',
                type: 'GET',
                dataType: ''
            });
        })
    }
}

window.LeakedPasswordInfo = LeakedPasswordInfo;